import React, { useState } from "react";
import { Redirect } from "react-router";

// Custom Components
import Table from "@Components/Table";
import Filter from "@Components/Filter";
import { useTranslation } from "react-i18next";

import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  HARI_TERABAI_DAY_URL,
  REGION_FETCH_URL,
  URLS,
  ZONE_FETCH_URL,
} from "configs/constants";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { COMPANY_FETCH_URL } from "configs/constants";

let model = [
  { id: "date", label: "Date", type: "date" },
  { id: "estate_code", label: "Estate Code", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "division_code", label: "Division Code", type: "string" },
  { id: "division_name", label: "Division Name", type: "string" },
  { id: "block_code", label: "Block Code", type: "string" },
  { id: "block_name", label: "Block Name", type: "string" },
];

const actions = ["edit", "delete"];

export default function HariTerabaiDay() {
  const { t } = useTranslation();
  const [filterValues, setFilterValues] = useState({});
  const [hariTerabai, setHariTerabai] = useState(true);
  const [weekend, setWeekend] = useState(false);
  const [holiday, setHoliday] = useState(false);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [disableZone, setDisableZone] = useState(true);
  const [tabValue, setTabValue] = useState("hari_terabai");

  const filterFields = [
    {
      type: "datepicker",
      label: "Date From",
      name: "start_date",
    },
    {
      type: "datepicker",
      label: "Date To",
      name: "end_date",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      required: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      disabled:disableZone,
      optionsDependsOn: "company",
      paginated: true,
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      optionsDependsOn: "zone",
      disabled: disableRegion,

      getValue: (e) => getRegionValues(e, setDisableEstate),

    },
    {
      type: "reactselect",
      label: "Estate",
      name: "estate",
      optionsDependsOn: "region",
      paginated: true,
      proxyUrl: ESTATE_FETCH_URL,
      disabled: disableEstate,

      getValue: (e) => getEstateValues(e, setDisableDivision),

    },
    {
      type: "reactselect",
      label: "Division",
      name: "division",
      optionsDependsOn: "estate",
      paginated: true,
      proxyUrl: DIVISION_FETCH_URL,
      disabled: disableDivision,

      getValue: (e) => getDivisonValues(e, setDisableBlock),

    },
    {
      type: "reactselect",
      label: "Block",
      name: "block",
      optionsDependsOn: "division",
      paginated: true,
      disabled: disableBlock,

      proxyUrl: BLOCK_FETCH_URL,
    },
  ];
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getZoneValues = (e, setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
  
  };
  const getRegionValues = (e, setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
  
  };
  
  const getEstateValues = (e, setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
  
  };
  const getDivisonValues = (e, setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
  
  };

  const filterInitialValues = {
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    type_of_attendance: "",
  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const handleChange = (event, newValue) => {
    let type = newValue;
    if (type === "holiday") {
      setHariTerabai(false);
      setHoliday(true);
      setTabValue(type);
    } else if (type === "weekend") {
      setWeekend(true);
      setHariTerabai(false);
      setTabValue(type);
    } else {
      console.log(type);
    }
  };

  if (hariTerabai) {
    return (
      <div>
        <div>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab value="holiday" label={t("Public Holiday")} />
              <Tab value="weekend" label={t("Weekend")} />
              <Tab value="hari_terabai" label="Hari Terabai" />
            </Tabs>
          </Box>
        </div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        />
        <Table
          proxyURL={HARI_TERABAI_DAY_URL}
          model={model}
          filterValues={filterValues}
          actions={actions}
          noFilter
        />
      </div>
    );
  } else if (holiday) {
    return <Redirect to={URLS.NON_WORKING_DAY_GLOBAL} />;
  } else if (weekend) {
    return <Redirect to={URLS.NON_WORKING_DAY_WEEKEND} />;
  } else {
    console.log("no where to go.");
  }
}
